import React from 'react'
import { CAREGIVER_OVERLAY_TITLE, CAREGIVER_OVERLAY_MESSAGE } from 'utils/constants'
import '../styles/d3/participantSelectionOverlay.scss'

const ParticipantSelectionOverlay = ({ title, message }) => {
  return (
    <div className='participant-selection-overlay'>
      <div className='participant-selection-overlay-card'>
        <h4 className='participant-selection-overlay-title'>{title || CAREGIVER_OVERLAY_TITLE}</h4>
        <p className='participant-selection-overlay-message'>
          {message || CAREGIVER_OVERLAY_MESSAGE}
        </p>
      </div>
    </div>
  )
}

export default ParticipantSelectionOverlay